var baseStyle = {
  borderWidth: '0.3em'
};
var sizes = {
  xs: {
    w: '.75rem',
    h: '.75rem',
    borderWidth: '0.15em'
  },
  sm: {
    w: '1rem',
    h: '1rem',
    borderWidth: '0.2em'
  },
  md: {
    w: '2rem',
    h: '2rem'
  },
  lg: {
    w: '2.5rem',
    h: '2.5rem'
  },
  xl: {
    w: '3rem',
    h: '3rem'
  }
};
var defaultProps = {
  size: 'md',
  color: 'blue.400'
};
var Spinner = {
  baseStyle: baseStyle,
  sizes: sizes,
  defaultProps: defaultProps
};
export { Spinner as default };